module.exports = __webpack_public_path__ + "img/delAccBtnUA.1422aae0.png";